/* eslint-disable */
import moment from 'moment';
import { ListTable } from '@/Components/ListTable';
import { useOpenChildQrActivitiesModal } from '@/Components/Modals/ChildQrActivitiesModal';
import Pagination from 'rsuite/Pagination';
import styles from './ScanWiseTable.module.scss';

// BE row shape (fmcg_packaging_helpers.getFmcgPackQrList):
//   { qrCode, packageId, isActive, childVariantId, packagingMappingId, storeId,
//     itemCount, totalWeight, batchId, completedAt, earliestExpiry }

const TABLE_COLUMNS = [
	{ title: 'Pack QR', config: { type: 'DATA' } },
	{ title: 'Status', config: { type: 'DATA' } },
	{ title: 'Items', config: { type: 'DATA' } },
	{ title: 'Weight', config: { type: 'DATA' } },
	{ title: 'Batch', config: { type: 'DATA' } },
	{ title: 'Completed', config: { type: 'DATA' } },
	{ title: 'Expiry', config: { type: 'DATA' } },
];

const COLMAP = {
	'Pack QR': 'qrCode',
	Status: 'isActive',
	Items: 'itemCount',
	Weight: 'totalWeight',
	Batch: 'batchId',
	Completed: 'completedAt',
	Expiry: 'earliestExpiry',
};

const PackQrTable = (props) => {
	const { data, page, total, pageSize, onPageChange } = props;
	const openChildQrActivities = useOpenChildQrActivitiesModal();

	const SPECIAL_ITEMS = {
		'Pack QR': (qrCodeVal, row) => (
			<button
				type='button'
				className='underline text-blue-400 hover:text-blue-600 bg-transparent border-0 p-0 cursor-pointer'
				onClick={() => openChildQrActivities(row?.packageId, qrCodeVal)}
				title='Show child QR activities'
			>
				{qrCodeVal}
			</button>
		),
		Status: (isActive) => {
			const label = isActive ? 'Active' : 'Inactive';
			const cls = isActive
				? 'inline-block px-2 py-0.5 rounded bg-green-100 text-green-800 text-xs font-semibold'
				: 'inline-block px-2 py-0.5 rounded bg-gray-200 text-gray-600 text-xs font-semibold';
			return <span className={cls}>{label}</span>;
		},
		Items: (itemCount) => (
			<div className='text-left'>{itemCount ?? '—'}</div>
		),
		Weight: (totalWeight) => (
			<div className='text-left'>
				{totalWeight != null ? totalWeight : '—'}
			</div>
		),
		Batch: (batchId) => (
			<div className='text-left'>{batchId || '—'}</div>
		),
		Completed: (completedAt) => (
			<div className='text-left'>
				{completedAt ? moment(completedAt).format('YYYY-MM-DD HH:mm') : '—'}
			</div>
		),
		Expiry: (earliestExpiry) => {
			if (!earliestExpiry) return <div className='text-left'>—</div>;
			const m = moment(earliestExpiry);
			const isPast = m.isBefore(moment(), 'day');
			return (
				<div className={`text-left ${isPast ? 'text-red-600 font-semibold' : ''}`}>
					{m.format('YYYY-MM-DD')}
				</div>
			);
		},
	};

	const getRowStyles = (ele) => {
		if (!ele?.isActive) return 'bg-gray-100 text-gray-500';
		return '';
	};

	return (
		<div className={`${styles.root} ${styles.small}`}>
			{total > 0 && onPageChange && (
				<div className='flex justify-end px-4 py-2 border-b border-gray-200'>
					<Pagination
						prev
						next
						first
						last
						ellipsis
						boundaryLinks
						maxButtons={7}
						size='sm'
						layout={['total', '-', 'pager']}
						total={total}
						limit={pageSize ?? 20}
						activePage={page ?? 1}
						onChangePage={onPageChange}
					/>
				</div>
			)}
			<ListTable
				allowCheckList={false}
				colMap={COLMAP}
				columns={TABLE_COLUMNS}
				data={(data || []).map((ele) => ({
					...ele,
					rowStyles: getRowStyles(ele),
				}))}
				special={{
					...SPECIAL_ITEMS,
				}}
				fixedHeaderTop={0}
			/>
		</div>
	);
};

export default PackQrTable;
